import { combineReducers } from '@reduxjs/toolkit';
import { configSlice } from '@/store/app/config.slice.ts';
import { authSlice } from '@/store/app/auth.slice.ts';

export const appReducer = combineReducers({
  config: configSlice.reducer,
  auth: authSlice.reducer
});
